import React from 'react';
import { CheckIcon, ChevronRightIcon } from 'lucide-react';
export const ProductCard = ({
  title,
  description,
  subDescription,
  learnMoreLink,
  isSelected = false,
  onClick
}) => {
  return <div className={`border rounded-lg p-4 mb-4 cursor-pointer ${isSelected ? 'border-[#5c5cf5]' : 'border-gray-200'}`} onClick={onClick} data-id="element-425">
      <div className="flex justify-between items-start" data-id="element-426">
        <div data-id="element-427">
          <h3 className="font-bold" data-id="element-428">{title}</h3>
          <p className="text-gray-700" data-id="element-429">{description}</p>
          {subDescription && <p className="text-gray-700 mt-1" data-id="element-430">{subDescription}</p>}
          <a href={learnMoreLink} className="text-[#5c5cf5] text-sm flex items-center mt-1" data-id="element-431">
            Learn more <ChevronRightIcon size={16} data-id="element-432" />
          </a>
        </div>
        <div className={`w-6 h-6 rounded-full flex items-center justify-center ${isSelected ? 'bg-[#5c5cf5]' : 'border border-gray-300'}`} data-id="element-433">
          {isSelected && <CheckIcon size={16} className="text-white" data-id="element-434" />}
        </div>
      </div>
    </div>;
};